module.exports = __webpack_public_path__ + "img/paypal.fc8a7e7.svg";